import { pathOr, lensPath, set, map } from 'ramda';
import { compose } from 'recompose';
import { API_ROOT } from 'src/constants';
import { authenticatedUser } from 'src/utilities/storage';
import { KIND_LOANAPP, KIND_LOANAPP_ROLE, STATUS_PENDING } from '../constants';
import { mkObject, setOwnerReference } from './build';
import { PENDING } from '../constants/activites';



export interface EventBody {
  source_provider: string;
  source: string;
  action: string;
  payload_raw: string;
  triggered_by: string;
  status: {
    phase: string;
  }
}

export interface EventPayload {
  api_root: string;
  event: EventBody;
}

export interface EventBatchPayload {
  api_root: string;
  event: EventBody[]
}


const getEventData = (dataBag: any) => {
  const { eventData, updDocs = {}, } = dataBag;
  const accountId =
    authenticatedUser.accountId.get() || pathOr('', ['objects', 'account'], eventData);
  // All ownerreferences should be sent from the event payload data (e)

  const ownerReferences = pathOr(
    [],
    ['object_meta', 'owner_references'],
    eventData
  );
  const baseData = {
    ...eventData,
    document_category: pathOr('', ['document_category'], updDocs),
    document_artifact: pathOr('', ['document_artifact'], updDocs)
  }
  const base64Data = base64Encode(baseData);
  const object_meta = mkObject('Event-1621');
  const objectMeta = compose(
    set(lensPath(['object_meta', 'owner_references']), ownerReferences),

  )({
    object_meta,
  });
  const triggeredBy = pathOr("", ['triggeredBy'], eventData);
  pathOr('', ['document_artifact'], updDocs)

  return {
    accountId,
    base64Data,
    triggeredBy,
    objectMeta,
  }

}

export const mkEventsBridgeData = (source: string, action: string, eventData: any, updDocs?: any): EventPayload => {
  const { accountId, base64Data, objectMeta, triggeredBy } = getEventData({ eventData, updDocs })
  return {
    api_root: API_ROOT,
    event: {
      //This is being used in go lamda
      ...objectMeta,
      source_provider: 'lendsmart_sh/worklets',
      source: source,
      action: action,
      payload_raw: base64Data,
      triggered_by: triggeredBy ? triggeredBy : `lendsmart_sh/${accountId}`,
      status: {
        phase: PENDING,
      }
    }
  } as EventPayload;
};


export const mkBatchEventsBridgeData = (eventBatch: any): EventBatchPayload => {
  const event = map((event: any) => {
    const source = pathOr('', ['source'], event)
    const action = pathOr('', ['action'], event)
    const eventData = pathOr('', ['payload'], event)
    const evenPayload = pathOr({}, ['event'], mkEventsBridgeData(
      source,
      action,
      eventData
    ))
    return evenPayload as EventBody
  }, eventBatch)

  return {
    api_root: API_ROOT,
    event
  }
}

const base64Encode = (data: any) => {
  let objJsonStr = JSON.stringify(data);
  return Buffer.from(objJsonStr).toString('base64');
};
export const mkEventsBridgeDeleteLoan = (
  source: string,
  action: string,
  e: any
) => {
  const accountId =
    authenticatedUser.accountId.get() || pathOr('', ['objects', 'account'], e);
  const thisLoanId = pathOr('', ['thisLoanId'], e);
  const thisLoanRoleId = pathOr('', ['roleId'], e);
  const base64Data = base64Encode({});
  const object_meta = mkObject('Event-1621');
  const data = compose(
    setOwnerReference(thisLoanId, KIND_LOANAPP),
    setOwnerReference(thisLoanRoleId, KIND_LOANAPP_ROLE)
  )({
    object_meta,
  });
  return {
    api_root: API_ROOT,
    event: {
      source_provider: 'lendsmart_sh/worklets',
      ...data,
      source: source,
      action: action,
      payload_raw: base64Data,
      triggered_by: `lendsmart_sh/${accountId}`,
      status: {
        phase: STATUS_PENDING,
      },
    },
  };
};
